import React from 'react';
import PropTypes from 'prop-types';
import { default as ReactModal } from 'react-modal';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, onClose: PropTypes.func };

const defaultProps = { ...Abstrap.defaultProps, componentClass: ReactModal };

class Modal extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-modal',
            className,
        ];
    }

    render() {
        const { children, onClose } = this.props;
        return (
            <this.props.componentClass
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...this.filterProps()}
                className={this.getClassName()}
                overlayClassName="c-modal__backdrop"
                isOpen
                contentLabel="Modal"
                appElement={document.querySelector('.c-leftnav')}
                onRequestClose={onClose}
                ariaHideApp={false}
                shouldCloseOnOverlayClick
            >
                {children}
            </this.props.componentClass>
        );
    }

}

Modal.propTypes = propTypes;

Modal.defaultProps = defaultProps;

export default Modal;
